import { RefreshCw } from "lucide-react";

const STATS = [["pts", "PTS"], ["reb", "REB"], ["ast", "AST"], ["fg3m", "3PM"], ["pra", "PRA"]];

function Block({ title, g, testid }) {
  return (
    <tr data-testid={testid}>
      <td className="sm-name"><b>{title}</b><small>{g.n} rows</small></td>
      {STATS.map(([k]) => {
        const s = g[k];
        const better = s.new_mae < s.x4_mae;
        return (
          <td key={k} className="sm-num">
            <b className={better ? "win" : ""}>{s.new_mae.toFixed(2)}</b><small>x4 {s.x4_mae.toFixed(2)}</small>
            <small className="sm-bias">bias {s.new_bias >= 0 ? "+" : ""}{s.new_bias.toFixed(2)} / {s.x4_bias >= 0 ? "+" : ""}{s.x4_bias.toFixed(2)}</small>
          </td>
        );
      })}
    </tr>
  );
}

export function Backtest({ report, running, onRun }) {
  const groups = report?.groups || {};
  const order = Object.keys(groups).filter((k) => !k.startsWith("team:"));
  const teams = Object.keys(groups).filter((k) => k.startsWith("team:"));
  return (
    <section className="sm-team" data-testid="sm-backtest">
      <header className="sm-team-head">
        <h3>BACKTEST · NEW MODEL vs x4</h3>
        <span className="sm-meta">{report?.created_at ? `Run ${new Date(report.created_at).toLocaleString("en-GB")} · season ${report.season}` : "Not run yet"}</span>
        <button type="button" className="sm-btn" onClick={onRun} disabled={running} data-testid="sm-run-backtest"><RefreshCw size={14} className={running ? "spin" : ""} />{running ? "Running…" : "Run backtest"}</button>
      </header>
      {report?.groups && (
        <>
          <p className="sm-dim">Mean absolute error per player-game (lower is better; green = new model better). Rolling pre-game: every game uses only earlier games.</p>
          <div className="sm-splits">
            <div><small>Expected minutes MAE</small><b data-testid="sm-bt-minutes">new {report.minutes.new_mae ?? "—"} · x4 {report.minutes.x4_mae ?? "—"}</b></div>
            <div><small>Skipped</small><b>{Object.entries(report.skipped).map(([k, v]) => `${v} ${k}`).join(" · ") || "none"}</b></div>
          </div>
          <div className="sm-tablewrap">
            <table className="sm-table">
              <thead><tr><th>GROUP</th>{STATS.map(([, l]) => <th key={l}>{l}<small>new · x4</small></th>)}</tr></thead>
              <tbody>
                <Block title="Team totals" g={report.team_totals} testid="sm-bt-team" />
                {order.map((k) => <Block key={k} title={k.replace(":", " · ")} g={groups[k]} testid={`sm-bt-${k.replace(":", "-")}`} />)}
                {teams.map((k) => <Block key={k} title={k.replace(":", " · ")} g={groups[k]} testid={`sm-bt-${k.replace(":", "-")}`} />)}
              </tbody>
            </table>
          </div>
          {report.notes.map((n) => <p key={n} className="sm-dim">· {n}</p>)}
        </>
      )}
    </section>
  );
}
